/* global angular */

angular.module('AemCspsMillionChild')
  .component('birthDate', {
    template: require('./birth-date.component.tpl.html'),
    controller: BirthDateCtrl,
    controllerAs: 'vm',
    bindings: {
      label: '@',
      month: '<',
      year: '<',
      relativeToDate: '<',
      onChanged: '&'
    }
  })

BirthDateCtrl.$inject = ['$timeout']

function BirthDateCtrl ($timeout) {
  var vm = this

  vm.$onInit = function () {
    vm.years = getYears()
    vm.months = getMonths(vm.year, vm.month)
    vm.month = setCurrentMonth(vm.months, vm.month)
    vm.onChange = onChange
  }

  function getYears () {
    var currentYear = new Date().getFullYear()
    var years = []
    for (var i = currentYear; i >= currentYear - 18; i--) {
      years.push(i)
    }
    return years
  }

  function getMonths (yearOfBirth, monthOfBirth) {
    var currentYear = new Date().getFullYear()
    var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    if (yearOfBirth === currentYear - 18) {
      months = []
      var maxMonth = new Date().getMonth() + 2
      for (var i = maxMonth; i < 13; i++) {
        months.push(i)
      }
    }
    return months
  }

  function setCurrentMonth (months, month) {
    if (months.indexOf(month) === -1) {
      return months[0]
    }
    return month
  }

  function onChange () {
    vm.months = getMonths(vm.year, vm.month)
    vm.month = setCurrentMonth(vm.months, vm.month)
    $timeout(vm.onChanged({ month: vm.month, year: vm.year }))
  }
}
